import ProductCard from './ProductCard';
import React, { useState, useEffect, useContext } from 'react';
import { PlanoContext } from './PlanoContext';
import { useDrop } from 'react-dnd';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Grid,
} from '@material-ui/core';

export default function ProductList({
  cates,
  handleSave,
  laneLength,
  search,
  setSearch,
  TCN,
  setProds,
  toggleBox,
  setBoxes,
  rows,
  columns,
  setRows,
  setColumns,
  url,
}) {
  const { prods, error, setError, dragProd, setDragProd } = useContext(PlanoContext);

  // const [search, setSearch] = useState('');
  const [cate, setCate] = useState('All Categories');
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleToggleBox = () => {
    setIsCollapsed(!isCollapsed);
    toggleBox(); // 调用原来的toggleBox函数
  };

  const generateBoxes = () => {
    const newBoxes = {
      rows,
      columns,
      boxes: [],
      floors: [],
    };
    let floors = [];

    for (let i = 0; i < rows; i++) {
      floors.push({
        row: i + 1,
      });
    }

    floors.forEach((element, idx) => {
      element.lines = [];
      for (let i = 0; i < columns; i++) {
        element.lines.push({
          id: `${i + 1}-${idx + 1}`,
          row: idx + 1,
          column: i + 1,
          borrowed: false,
          rent: false,
          product: null,
          disabled: false,
          useForLink: false,
          type: '0',
          linkArray: [],
        });
      }
    });
    setBoxes({ rows, columns, floors });
    console.log('newBoxes', { rows, columns, floors });
    // setBoxes(newBoxes?.boxes);
  };
  const [{ isOver }, drop] = useDrop(() => ({
    accept: ['product', 'placed-product', 'boxProduct'], // Accept products from list, planogram, and boxes
    drop: (item, monitor) => {
      // If it's a product from planogram, it will be removed via Droped.js end callback
      // If it's a product from a box, it will be handled by the DropBox component's end callback
      const itemType = monitor.getItemType();
      if (itemType === 'boxProduct') {
        console.log('Product removed from box and returned to product list');
      } else if (itemType === 'placed-product') {
        console.log('Product removed from planogram and returned to product list');
      }
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  let newProds = prods.filter((val) => {
    let c1 = val?.category?.map((e) => e.name);
    if (search == '') {
      if (cate == 'All Categories') {
        return val;
      } else if (c1?.length > 0 && c1.join(', ').toLowerCase().includes(cate.toLowerCase())) {
        return val;
      }
    } else if (val.name.toLowerCase().includes(search.toLowerCase())) {
      if (cate == 'All Categories') {
        return val;
      } else if (c1?.length > 0 && c1.join(', ').toLowerCase().includes(cate.toLowerCase())) {
        return val;
      }
    }
    // }
  });

  // newProds.filter((val) => {
  //   // console.log(val);
  //   console.log('dgprod', dragProd);
  //   if (val.name === dragProd) {
  //     console.log(val.name);
  //     return val;
  //   }
  // });

  return (
    <div className="Plano-Products" ref={drop} style={{ position: 'relative' }}>
      {/* Drop zone indicator when dragging from box */}
      {isOver && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 107, 107, 0.3)',
            border: '3px dashed #ff6b6b',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            pointerEvents: 'none',
          }}
        >
          <div
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              padding: '20px',
              borderRadius: '10px',
              textAlign: 'center',
              border: '2px solid #ff6b6b',
            }}
          >
            <span
              style={{
                color: '#ff4757',
                fontWeight: 'bold',
                fontSize: '18px',
                display: 'block',
              }}
            >
              🗑️ Remove Product
            </span>
            <span style={{ color: '#666', fontSize: '14px' }}>
              Drop here to remove from planogram
            </span>
          </div>
        </div>
      )}

      <div className="plano-wrapper">
        <div className="plano-product-title">
          <h4 style={{ margin: '0px' }}>Products List</h4>
        </div>
        <div className="searchPlano">
          <TextField
            onChange={(event) => {
              setSearch(event.target.value);
            }}
            fullWidth
            label="Search..."
          />
        </div>
        <div className="searchPlano">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Category</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={cate}
              onChange={(event) => {
                setCate(event.target.value);
              }}
            >
              <MenuItem value="All Categories">All Categories</MenuItem>;
              {cates.map((item, i) => {
                return (
                  <MenuItem key={i} value={item.name}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </div>
        <div className={`plano-scrollable ${isCollapsed ? 'collapsed' : ''}`}>
          {newProds.map((prod, i) => {
            return (
              <ProductCard
                newProds={newProds}
                i={i}
                newURL={url}
                TCN={TCN}
                url={`${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}?quality=10`}
                error={error}
                setError={setError}
                prod={prod}
                key={i}
                laneLength={laneLength}
                setProds={setProds}
              />
            );
          })}
        </div>
        <div className="mb-1 mt-1">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            style={{ height: '50px', marginTop: '20px' }}
          >
            Save My Planogram
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleToggleBox}
            style={{ height: '50px', marginTop: '20px', marginLeft: '20px' }}
          >
            {isCollapsed ? 'Planogram' : 'Locker box'}
          </Button>
        </div>
        {isCollapsed && (
          <Grid
            container
            spacing={2}
            alignContent="center"
            justifyContent="cneter"
            style={{ marginTop: '20px' }}
          >
            <Grid item xs={4}>
              <TextField
                type="number"
                label="Columns"
                variant="outlined"
                onChange={(e) => setColumns(parseInt(e.target.value))}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                type="number"
                label="Rows"
                variant="outlined"
                onChange={(e) => setRows(parseInt(e.target.value))}
              />
            </Grid>
            <Grid item xs={4}>
              <Button variant="contained" color="primary" onClick={generateBoxes}>
                Generate Boxes
              </Button>
            </Grid>
          </Grid>
        )}
      </div>
    </div>
  );
}
